import React from "react";
import {
  ReactiveBase,
  DataSearch,
  MultiDropdownList,
  MultiList,
  SelectedFilters,
  ReactiveList,
} from "@appbaseio/reactivesearch";
function App() {
  return (
    <ReactiveBase
      app="production"
      url="https://paas:6a9b9b9c0b18c9d88c610c1723dd751d@dori-us-east-1.searchly.com"
    >
      <div className="w-full flex flex-col search">
        <div className="w-full flex flex-wrap -mx-4">
          <div className="w-full md:w-1/4 flex flex-col px-4 space-y-8">
            <div>
              <h2>Grade</h2>
              <MultiDropdownList
                componentId="Grades"
                showClear={true}
                dataField="grade"
                sortBy="asc"
                react={{
                  and: ["SearchInput"],
                }}
              />
            </div>
            <div>
              <h2>Resource Type</h2>
              <MultiDropdownList
                componentId="Type"
                dataField="resource_type"
                sortBy="asc"
                react={{
                  and: ["SearchInput"],
                }}
              />
            </div>
            <div>
              <h2>Subject</h2>
              <MultiDropdownList
                componentId="Subjects"
                dataField="subject"
                sortBy="asc"
                react={{
                  and: ["SearchInput"],
                }}
              />
            </div>
            <div>
              <h2>Standards</h2>
              <MultiList
                size={5000}
                className="standards-search"
                componentId="Standards"
                showCheckbox={false}
                URLParams={true}
                dataField="standards"
                renderListItem={(label, count) => (
                  <p>
                    {label}&nbsp;({count})
                  </p>
                )}
                sortBy="asc"
                react={{
                  and: ["SearchInput"],
                }}
              />
            </div>
            <div>
              <h2>Materials</h2>
              <MultiList
                className="mats-search"
                componentId="Materials"
                dataField="materials"
                size={5000}
                showCount={false}
                showCheckbox={false}
                renderListItem={(label, count) => <p>{label}</p>}
                sortBy="asc"
                react={{
                  and: ["SearchInput"],
                }}
              />
            </div>
          </div>
          <div className="w-full md:w-3/4 px-4 flex flex-col">
            <div className="flex flex-col w-full">
              <DataSearch
                componentId="SearchInput"
                dataField={["title", "objective", "content"]}
                categoryField="title"
                placeholder="Search"
                debounce={100}
                URLParams={true}
                autosuggest={false}
                queryFormat="and"
                style={{
                  width: "100%",
                }}
              />
              <SelectedFilters />
            </div>
            <div>
              <ReactiveList
                pagination={true}
                componentId="SearchResult"
                dataField="content.title"
                size={10}
                showClear={true}
                react={{
                  and: [
                    "SearchInput",
                    "Grades",
                    "Type",
                    "Subjects",
                    "Standards",
                    "Materials",
                  ],
                }}
                onResultStats={(total) => {
                  return "";
                }}
                renderItem={(res) => (
                  <div className="w-full py-2" key={res.id}>
                    <h4>
                      <a href={res.url} dangerouslySetInnerHTML={{ __html: res.title }}></a>
                    </h4>
                    <p dangerouslySetInnerHTML={{ __html: res.description }} />
                  </div>
                )}
              />
            </div>
          </div>
        </div>
      </div>
    </ReactiveBase>
  );
}

export default App;
